/** Orden y valores enviados al backend (alineado con cuenta bancaria existente) */
export const BANCO_OPTIONS = [
  { label: "BROU", value: "BROU" },
  { label: "Bandes", value: "Bandes" },
  { label: "BHU", value: "Banco Hipotecario del Uruguay" },
  { label: "Citibank", value: "Citibank" },
  { label: "Itau", value: "Itau" },
  { label: "Scotiabank", value: "Scotiabank" },
  { label: "Santander", value: "Santander" },
  { label: "Banco de la Nación Argentina", value: "Banco de la Nación Argentina" },
  { label: "BBVA", value: "BBVA" },
  { label: "HSBC", value: "HSBC" },
  { label: "Heritage", value: "Heritage" },
  { label: "PREX", value: "PREX" },
  { label: "MIDINERO", value: "MIDINERO" },
  { label: "OCA Blue", value: "OCA Blue" },
];

export function restriccionesPorBanco(banco) {
  switch (banco) {
    case "BROU":
      return { minLength: 14, maxLength: 14 };
    case "Banco Hipotecario del Uruguay":
      return { minLength: 10, maxLength: 10 };
    case "Citibank":
      return { minLength: 10, maxLength: 10 };
    case "Itau":
      return { minLength: 7, maxLength: 7 };
    case "Scotiabank":
      return { minLength: 10, maxLength: 10 };
    case "Santander":
      return { minLength: 16, maxLength: 16 };
    case "Banco de la Nación Argentina":
      return { minLength: 12, maxLength: 12 };
    case "BBVA":
      return { minLength: 9, maxLength: 9 };
    case "HSBC":
      return { minLength: 10, maxLength: 10 };
    case "Heritage":
      return { minLength: 9, maxLength: 9 };
    case "PREX":
      return { minLength: 8, maxLength: 8 };
    case "MIDINERO":
      return { minLength: 7, maxLength: 7 };
    case "OCA Blue":
      return { minLength: 7, maxLength: 7 };
    case "Bandes":
    default:
      return { minLength: 20, maxLength: 20 };
  }
}
